import type { IntegrationSettings } from "common/types";

import CrmIntegrationSettings from "./CrmIntegrationSettings";
import EmailBisonSettings from "./EmailBisonSettings";
import Rb2bIntegrationSettings from "./Rb2bIntegrationSettings";
import SmartleadAndInstantlySettings from "./SmartleadAndInstantlySettings";

interface ConnectedIntegrationSettingsProps<
  K extends keyof IntegrationSettings,
> {
  integrationKey: K;
  settings: IntegrationSettings[K];
}

export default function ConnectedIntegrationSettings<
  K extends keyof IntegrationSettings,
>({ integrationKey, settings }: ConnectedIntegrationSettingsProps<K>) {
  const integrationSettings: IntegrationSettings[keyof IntegrationSettings] =
    settings;

  const errorMessage =
    integrationSettings && "error" in integrationSettings
      ? integrationSettings.error
      : null;

  if (integrationKey === "hubspot" || integrationKey === "pipedrive") {
    return (
      <CrmIntegrationSettings
        crmExportType={integrationKey}
        {...("active" in integrationSettings
          ? { settings: integrationSettings }
          : { errorMessage })}
      />
    );
  }

  if (integrationKey === "rb2b") {
    return (
      <Rb2bIntegrationSettings
        settings={
          integrationSettings && "campaign_id" in integrationSettings
            ? integrationSettings
            : null
        }
      />
    );
  }

  if (integrationKey === "emailbison") {
    return "user_name" in integrationSettings ? (
      <EmailBisonSettings
        userName={integrationSettings.user_name}
        customUrl={integrationSettings.custom_url}
      />
    ) : (
      <EmailBisonSettings errorMessage={errorMessage} />
    );
  }

  if (integrationKey === "instantly") {
    return "workspace_name" in integrationSettings ? (
      <SmartleadAndInstantlySettings
        type="instantly"
        workspaceName={integrationSettings.workspace_name}
      />
    ) : (
      <SmartleadAndInstantlySettings
        type="instantly"
        errorMessage={errorMessage}
      />
    );
  }

  return (
    <SmartleadAndInstantlySettings
      type="smartlead"
      apiKey={
        "api_key" in integrationSettings ? integrationSettings.api_key : null
      }
    />
  );
}
